import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { effects } from './effects';
import { CityEventModule } from './events/city/city-event.module';

@NgModule({
  imports: [CityEventModule, EffectsModule.forFeature(effects)],
})
export class CityFeatureModule {}
